import { NavLink } from 'react-router-dom';
import { IconChart } from '../../components/ui/icons';

const tiles = [
  {
    to: '/provider/reports/intake-throughput',
    title: 'Intake throughput',
    body: 'Volume, speed, aging, and source concentration.',
    chip: 'Intake',
  },
  {
    to: '/provider/reports/authority-outcomes',
    title: 'Authority outcomes',
    body: 'Candidate, repository-only, duplicate-block, and admit outcomes.',
    chip: 'Authority',
  },
  {
    to: '/provider/reports/custody-handoff',
    title: 'Custody packaging & handoff',
    body: 'Ready for custodian, delayed, and executed handoff states.',
    chip: 'Handoff',
  },
  {
    to: '/provider/reports/integration-health',
    title: 'Integration health',
    body: 'API, webhook, SFTP, and partner feed reliability.',
    chip: 'Integrations',
  },
];

export function ProviderReportsHubPage() {
  return (
    <div className="space-y-5">
      <section className="rounded-2xl border border-eorig-border bg-white p-4 shadow-eorig-card sm:p-5">
        <div className="flex items-start gap-3">
          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-eorig-surface text-eorig-navy-600">
            <IconChart className="h-4 w-4" />
          </span>
          <div className="min-w-0">
            <h2 className="text-sm font-semibold text-eorig-ink">
              Provider report modules
            </h2>
            <p className="mt-1 text-xs leading-relaxed text-eorig-muted">
              Tiles are navigation only. Run, schedule, and export live inside
              each dashboard.
            </p>
          </div>
        </div>
      </section>

      <ul className="grid gap-3 sm:grid-cols-2">
        {tiles.map((tile, i) => (
          <li key={tile.to}>
            <NavLink
              to={tile.to}
              className="group relative block h-full rounded-2xl border border-eorig-border bg-white p-4 shadow-eorig-card transition-colors hover:border-eorig-cyan/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-eorig-cyan/35"
            >
              <span className="absolute right-3 top-3 text-2xl font-bold tabular-nums text-eorig-border">
                {String(i + 1).padStart(2, '0')}
              </span>
              <span className="inline-block rounded-md bg-eorig-surface px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-eorig-navy-600">
                {tile.chip}
              </span>
              <h3 className="mt-2 pr-10 text-sm font-semibold text-eorig-ink group-hover:text-eorig-navy-600">
                {tile.title}
              </h3>
              <p className="mt-1 text-xs leading-relaxed text-eorig-muted">
                {tile.body}
              </p>
              <span className="mt-3 inline-flex items-center gap-1 text-xs font-semibold text-eorig-navy-600 group-hover:text-eorig-cyan">
                Open dashboard →
              </span>
            </NavLink>
          </li>
        ))}
      </ul>
    </div>
  );
}
